// MST
import { types, flow, cast } from 'mobx-state-tree'

import {
  IAboutUsMottoGetAttrs,
  IAboutUsMottoSaveAttrs,
} from 'interfaces/back-office/content-management/about-us/motto/about-us-motto-view.interface'
import {
  IAboutUsMottoApiGetResponse,
  IAboutUsMottoApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/motto/about-us-motto-api.interface'
import { IAboutUsMotto } from 'interfaces/back-office/content-management/about-us/motto'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'

// About Us Motto Props
const aboutUsMottoProps = {
  id: types.maybeNull(types.number),
  content: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  status: types.maybeNull(types.boolean),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
}

const AboutUsMotto = types.model('aboutUsMotto').props(aboutUsMottoProps)

const AboutUsMottoStoreModel = types
  .model('aboutUsMotto')
  .props({
    aboutUsMotto_isLoading: types.optional(types.boolean, false),
    aboutUsMotto_isSaveLoading: types.optional(types.boolean, false),
    aboutUsMotto_aboutUsMotto: types.optional(AboutUsMotto, {}),
  })
  .actions(self => ({
    aboutUsMotto_SET_LOADING: (payload: boolean): void => {
      self.aboutUsMotto_isLoading = payload
    },
    aboutUsMotto_SET_SAVE_LOADING: (payload: boolean): void => {
      self.aboutUsMotto_isSaveLoading = payload
    },
    aboutUsMotto_SET_ABOUT_US_MOTTO: (payload: IAboutUsMotto): void => {
      self.aboutUsMotto_aboutUsMotto = cast(payload)
    },
    aboutUsMotto_CLEAR_ABOUT_US_MOTTO: (): void => {
      self.aboutUsMotto_aboutUsMotto = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch about us motto
     *
     * @param {IAboutUsMottoGetAttrs} payload
     *
     * @return {any} any
     */
     aboutUsMotto_fetchAboutUsMotto: flow(function* (payload: IAboutUsMottoGetAttrs) {
      self.aboutUsMotto_SET_LOADING(true)

      const response: IAboutUsMottoApiGetResponse = yield self.environment.aboutUsMottoApi.aboutUsMotto_getAboutUsMotto({
        requestConfig: { ...payload.requestConfig },
      })
      if (response.ok) {
        self.aboutUsMotto_SET_ABOUT_US_MOTTO(response.res.data)

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response error
        if (payload?.onError) payload.onError()
      }

      self.aboutUsMotto_SET_LOADING(false)
    }),

    /**
     * @description Save about us motto
     *
     * @param {IAboutUsMottoSaveAttrs} payload
     *
     * @return {any} any
     */
    aboutUsMotto_saveAboutUsMotto: flow(function* (payload: IAboutUsMottoSaveAttrs) {
      self.aboutUsMotto_SET_SAVE_LOADING(true)

      const response: IAboutUsMottoApiSaveResponse = yield self.environment.aboutUsMottoApi.aboutUsMotto_saveAboutUsMotto({
        params: { ...payload.params },
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
      })
      if (response.ok) {
        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      self.aboutUsMotto_SET_SAVE_LOADING(false)
    }),
  }))

  export const createAboutUsMottoStoreDefaultModel = () => types.optional(AboutUsMottoStoreModel, {})